import PropTypes from 'prop-types'
import InputAdornment from '@mui/material/InputAdornment'
import Typography from '@mui/material/Typography'
import {StyledTextField} from '../../AdminPanelStyling'

const TextFieldWithCounter = ({
  value,
  onChange,
  label,
  name,
  maxLength,
  enforceMaxLength,
  error,
  helperText,
  disabled,
  fullWidth,
  size,
  textFieldProps
}) => {
  const currentLength = value.length
  const isLimitBreached = currentLength > maxLength

  const existingNativeInputProps = textFieldProps?.inputProps || {}
  const existingInputProps = textFieldProps?.InputProps || {}

  const handleChange = (event) => {
    if (enforceMaxLength && event.target.value.length > maxLength) {
      return
    }
    onChange(event)
  }

  return (
    <StyledTextField
      value={value}
      onChange={handleChange}
      label={label}
      name={name}
      fullWidth={fullWidth}
      size={size}
      error={error}
      helperText={helperText}
      disabled={disabled}
      {...textFieldProps}
      inputProps={{
        ...existingNativeInputProps,
        ...(enforceMaxLength ? {maxLength} : {})
      }}
      InputProps={{
        ...existingInputProps,
        endAdornment: (
          <InputAdornment position='end'>
            <Typography
              variant='caption'
              color={isLimitBreached ? 'error.main' : 'text.secondary'}
              data-testid='client-name-char-counter'
              data-overlimit={isLimitBreached ? 'true' : 'false'}
            >
              {`${currentLength}/${maxLength}`}
            </Typography>
          </InputAdornment>
        )
      }}
    />
  )
}

TextFieldWithCounter.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  name: PropTypes.string,
  maxLength: PropTypes.number,
  enforceMaxLength: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.node,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium']),
  textFieldProps: PropTypes.object
}

TextFieldWithCounter.defaultProps = {
  label: 'Client Name',
  name: undefined,
  maxLength: 100,
  enforceMaxLength: true,
  error: false,
  helperText: '',
  disabled: false,
  fullWidth: true,
  size: 'medium',
  textFieldProps: {}
}

export default TextFieldWithCounter
